<template>
	<div class="global-container">
		<div class="tabs-select">
			<label class="d-none d-lg-none label-event-categories" for="event-categories">Search Events</label>
			<select id="event-categories" class="form-control selectpicker" v-on:change="updateTabs($event.target.selectedIndex)" v-model="category" multiple>
				<option v-on:checked="allSelected" v-on:click="selectAll">All Events</option>
				<option v-if="!type.HideEvent" v-bind:value="type.CodeName" v-for="type in eventTypes" v-bind:key="type.CodeName">
					{{ type.DisplayName }}
				</option>
			</select>
			<div class="d-block event-checkbox-wrapper">
				<label class="d-none" for="event-categories">Search Events</label>
				<div id="event-categories" class="form-control" v-model="category">
					<div id="event-categories-label">Search Events:</div>
					<div class="options-wrapper">
						<input class="all-events-input" type="checkbox" v-on:checked="allSelected" v-on:click="selectAll" value="all-events" />
						<label class="all-events-label" for="all">All Events</label>
						<template>
							<label v-if="!type.HideEvent" v-bind:for="type.CodeName" v-for="type in eventTypes">
								<input type="checkbox" v-bind:id="type.CodeName" v-on:click="updateCheckbox($event.target, type, type.CodeName)" v-if="!type.HideEvent" v-bind:value="type.CodeName" v-model="type.selected" v-bind:title="type.DisplayName" v-bind:key="type.CodeName" />
								{{ type.DisplayName }}
							</label>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapMutations } from 'vuex';
	import { ref } from 'vue';
	import * as CONST from '../../utils/constants';
	import FilterGroup from '../ui/filter-group';

	export default {
		props: ['hideevents'],
		data: function () {
			return {
				eventTypes: CONST.globalProject.EventTypes,
				category: [],
				tabIndex: 0,
				currentSelections: null,
			}
		},
		mounted: function () {
			let urlParams = new URLSearchParams(window.location.search);
			let categoriesUrl = urlParams.get('category');
			let isAllStates = false;

			if(categoriesUrl != null){
				if(categoriesUrl.indexOf("all-events") != -1){
					isAllStates = true;
				}
			} else {
				this.selectAll();
				window.location.reload();
				//$(".js-toggle-category-menu .inner-text").text("All Events");
			}

			this.eventTypes.forEach((type, index) => {
				this.$set(type, "selected", false);
				if (type.IsActive) {
					this.tabIndex = index + 1;
					this.$set(type, "selected", false);
					this.category.push(type.CodeName);

					this.category.forEach(function (value, i) {
						if(!$("#"+value).parent().hasClass("checked") && !isAllStates){
							$("#"+value).parent().toggleClass("checked");
						}
					});
				}
			});

			if(isAllStates){
				$('.all-events-label').toggleClass('checked');
				$('.all-events-input').toggleClass('checked');
			}
		},
		computed: {
			allSelected() {
				return this.eventTypes.every(type => type.selected);
			}
		},
		methods: {
			...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			updateFilters() {
				// if hitting api on each checkmark change
				if (this.category.length === 0) {
					this.category.push('all-events');
					this.eventTypes.forEach((type, index) => {
						if(type.IsActive) {
							this.category.push(type.CodeName);
						}
					});
					$('.all-events-label').toggleClass('checked');
					$('.all-events-input').toggleClass('checked');
					this.updateSpecification({ key: 'Categories', value: this.category });
				}
				else {
					this.updateSpecification({ key: 'Categories', value: this.category });
					//this.setFilter();
					//window.location.reload();
					//vm.$forceUpdate();
				}
			},
			updateSelect(codeName) {
				if (this.tabIndex === 95) {
					this.category = [];
				}else {
					this.category.push(codeName);
				}

				this.updateFilters();
			},
			updateCheckbox(event, type, CodeName) {
				console.log('updateCheckbox', type, CodeName, event);
				$("#"+event.id).parent().toggleClass("checked");
				//$("#"+event.id).prop("selected", !type.selected);
				this.updateQueryString(type.CodeName);
			},
			updateTabs(index) {
				this.tabIndex = index;
				this.updateQueryString(this.category);
				this.updateFilters();

			},
			updateQueryString(codeName) {
				$('input').find(`[key='$(codeName)']`).prop('checked', true);
				var urlParams = new URLSearchParams(window.location.search);
				if (codeName === '') {
					window.history.pushState('', '', '?');
				}
				else if(!urlParams.has('category')){
					var pageUrl = '?category=' + codeName;
					window.history.pushState('', '', pageUrl);
					this.selected = true;
					this.updateSelect(codeName);
				}else{
					var categories = this.category;
					if($('.all-events-label').hasClass('checked') && codeName != $('.all-events-input').attr('value')){
						categories = [];
						this.category = categories;
						$(".all-events-input").removeClass("checked");
						$("label").removeClass("checked");
						$(`#${codeName}`).parent().toggleClass('checked');
						window.history.pushState('', '', '?category=');
					}
					
					if($.inArray(codeName, categories) !== -1){
						categories.forEach(function (value, i) {
							  if(value === codeName){
								  categories.splice(i,1);
							  }
						});

						if(categories.length === 0){
							urlParams.set('category','');
						}else{
							urlParams.set('category',categories.join(","));
						}
						var path = window.location.href.split('?')[0];
						var newURL = `${path}?${urlParams}`;

						window.history.pushState('', '', newURL);
						this.category = categories;
						this.updateFilters();
					}else{
						this.updateSelect(codeName);
					}
				}
			},
			selectAll() {
				let allStatesLabel = $('.all-events-label');
				let allStatesInput = $('.all-events-input');
				let stateCategories = $('.options-wrapper label');
				let allStatesCode = allStatesInput.attr('value');

				if(!allStatesLabel.hasClass('checked')){
					this.category.push(allStatesCode);
					$("label").removeClass("checked");
					allStatesLabel.toggleClass('checked');
					allStatesInput.toggleClass('checked');

					for (let i = 0; i < stateCategories.length; i++) {
						if(!$(stateCategories[i]).hasClass('checked') && !$(stateCategories[i]).hasClass('all-events-label')){
							//$(stateCategories[i]).toggleClass('checked');
							let stateValue = $(stateCategories[i]).find('input').attr('value');

							var urlParams = new URLSearchParams(window.location.search);
							if(!urlParams.has('category')){
								var pageUrl = '?category=' + stateValue;
								window.history.pushState('', '', pageUrl);
								this.selected = true;
								this.category.push(stateValue);
							}else{
								var categories = this.category;
								categories.push(stateValue);
								urlParams.set('category',categories.join(","));
								var path = window.location.href.split('?')[0];
								var newURL = `${path}?${urlParams}`;
								window.history.pushState('', '', newURL);
								this.category = categories;
							}
						}
					}
					//let all_s = this.allSelected;
					//this.eventTypes.forEach( type => type.selected = !all_s );
					this.updateFilters();
				}else{
					this.currentSelections = null;
					$("label").removeClass("checked");
					this.category = [];
					this.updateFilters();
				}
			}
        },
		watch: {
			eventTypes: {
				handler() {
					this.currentSelections = this.eventTypes.filter( type => type.selected ).map( type => type.CodeName ).toString();
					console.log("currentSelections", this.currentSelections);
				},
				deep: true
			},
			listing: function () {
                let vm = this;
                let sort = this.$store.state.listing.specification.Sort;

                this.checkForPastEvents(sort);
            }
		}
    }
</script>